import { isValid as isValidCpf } from '@fnando/cpf';
import { isValid as isValidCnpj } from '@fnando/cnpj';

const validationRules = {
  cpf: v => (v && isValidCpf(v)) || 'Você precisar fornecer um CPF válido.',
  cnpj: v => (v && isValidCnpj(v)) || 'Você precisar fornecer um CNPJ válido',
  cpfCnpj: v => (v && (isValidCpf(v) || isValidCnpj(v)) || `Você precisar fornecer um ${ v.length < 12 ? 'CPF' : 'CNPJ' } válido`),
  email: v => (/.+@.+/).test(v) || 'Endereçco de e-mail inválido.',
  passwordMinLength: v => (v && v.length >= 8) || 'Sua senha deve conter no mínimo 8 caracteres.',
  postalcode: v => v.length >= 8 || 'CEP deve ter 8 dígitos',
  postalcodeAlagoas: v => (v && v.startsWith('57')) || 'CEP deve começar com 57 e deve ser de Alagoas',
  required: v => !!v || 'Este campo não pode ficar em branco.',
  notNull: v => v === null ? 'Este campo não pode ficar em branco.' : true,
  number: v => !isNaN(v) || 'Insira um número válido',
};

export default validationRules;
